import { useMemo } from "react";
import { AUTH_SOURCE } from "../constants/authSource";
import { useGlobalStore } from "../context/UserContext/userContext";

// Selector to get studyId from wixUser
export const getWixStudyId = () => {
  const { wixUser } = useGlobalStore.getState();
  return wixUser?.oUserStudy?.studyId || null;
};

// React hook to get studyId from props, Wix, or URL
// Priority: 1. propStudyId, 2. Wix user data, 3. URL parameter
export function useStudyId(propStudyId) {
  const authSource = useGlobalStore((state) => state.authSource);
  const wixUser = useGlobalStore((state) => state.wixUser);
  const creUser = useGlobalStore((state) => state.creUser);
  return useMemo(() => {
    if (propStudyId) return propStudyId;
    if (authSource === AUTH_SOURCE.WIX) {
      return wixUser?.oUserStudy?.studyId || null;
    }
    if (authSource === AUTH_SOURCE.CRE) {
      return creUser?.oUserStudy?.studyId || null;
    }
    const params = new URLSearchParams(window.location.search);
    return params.get("StudyId");
  }, [propStudyId, authSource, wixUser, creUser]);
}
